export default __webpack_public_path__ + "static/fm-0922c33e9dca4f55b647a24fc6406275.png";